<div class="flex-content">
  <div class="content col-sm container-fluid">

    <div class="modal fade" id="selectedImageModal" >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img *ngIf="selectedImage" default="./assets/imgs/no_image.jpg" [srcset]="selectedImage">
          </div>
        </div>
      </div>
    </div>


    <!-- <div *ngFor="let key of datas | keys" class="row"> -->
    <div class="row">

      <div class="equipment col-sm-12">
        <h3 class="equipment-title col-sm-12">Multi Projection Theater</h3>


        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mpt/mpt1.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mpt/mpt1.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mpt/mpt2.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mpt/mpt2.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mpt/mpt3.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mpt/mpt3.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mpt/mpt4.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mpt/mpt4.jpg')"
              >
        </div>
      </div>

      <div class="equipment col-sm-12">
        <h3 class="equipment-title col-sm-12">Motion Capture System</h3>

        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mocap/mocap1.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mocap/mocap1')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mocap/mocap2.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mocap/mocap2.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'mocap/mocap3.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'mocap/mocap3.jpg')"
              >
        </div>
      </div>

      <div class="equipment col-sm-12">
        <h3 class="equipment-title col-sm-12">Stereoscopic System</h3>

        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'stereo/stereo1.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'stereo/stereo1.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'stereo/stereo2.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'stereo/stereo2.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'stereo/stereo3.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'stereo/stereo3.jpg')"
              >
        </div>
      </div>

      <div class="equipment col-sm-12">
        <h3 class="equipment-title col-sm-12">Multi Projection Room</h3>

        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'CFL2/CFLL_upload_0.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'CFL2/CFLL_upload_0.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'CFL2/CFLL_upload_1.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'CFL2/CFLL_upload_1.jpg')"
              >
        </div>
        <div class="equipment-box col-sm-12 col-md-4 col-lg-3">
          <img class="img-fluid" [src]="relPath + 'CFL2/CFLL_upload_5.jpg'"
              data-toggle="modal"
              data-target="#selectedImageModal"
              (click)="setSelectedImage(relPath + 'CFL2/CFLL_upload_5.jpg')"
              >
        </div>
      </div>


  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-equip/about-equip.component.html